import { Pipe, PipeTransform } from '@angular/core';
import { UnidadesService} from '../../services/unidades.service';
// Importación de Angular Fire 2
import { AngularFirestore } from 'angularfire2/firestore';
@Pipe({
    name: 'verificarAprobacionPlaneacion' // nombre del pipe en las directivas
})

export class VerificarAprobacionPipe implements PipeTransform {
    constructor(public afs: AngularFirestore) { }
    // Métdodo a implementar siempre
    transform(idReporte:string){
        return this.afs.collection('reportesCambioDeUnidad').doc(idReporte).valueChanges().take(1).map(unidad => unidad['aprobacionPlaneacion'])
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/verificar-aprobacion.pipe.ts